import { queryClient } from '../../store/queryClient';
import { userQueryOptions } from './api/user';

const YEAR_MILLIS = 31556952000;

const createDateYearFromNow = () => new Date(Date.now() + YEAR_MILLIS).toString();

export const initializeFoundation = async ({ setToken, setInvalidRoles }) => {
  try {
    const user = await queryClient.fetchQuery(userQueryOptions());
    if (user.roles.length === 0) {
      setInvalidRoles();
      return;
    }
    const token = 'dummyToken';

    setToken(token, 'refreshToken', createDateYearFromNow());
  } catch (error) {
    return error;
  }
};

export const signoutZitadel = () => {
  globalThis.location.href = '/logout';
};
